import React from 'react';

import styles from './ContentNotFound.module.scss';

// TODO: check with design what to show when there is no content

const ContentNotFound = () => {
  return (
    <div className={styles.container}>
      This page currently contains no information. Please check back soon for
      more updates!
    </div>
  );
};

export default ContentNotFound;
